import type { MetricMap } from '@/types';

export const METRIC_META: MetricMap = {
  LCP: {
    cn: '最大内容绘制（Largest Contentful Paint）：页面主内容（最大块）出现在屏幕上的时间，越小代表首屏主体呈现越快。',
    good: 2500,
    ni: 4000,
    unit: 'ms',
  },
  CLS: {
    cn: '累计布局偏移（Cumulative Layout Shift）：页面加载过程中布局跳动的程度，越小越稳定。',
    good: 0.1,
    ni: 0.25,
    unit: '',
  },
  INP: {
    cn: '交互到下一次绘制（Interaction to Next Paint）：衡量交互响应速度（点击/输入后到界面更新），越小越流畅。',
    good: 200,
    ni: 500,
    unit: 'ms',
  },
  FID: {
    cn: '首次输入延迟（First Input Delay）：首次交互到浏览器开始处理的延迟，越小越好（逐步被 INP 替代）。',
    good: 100,
    ni: 300,
    unit: 'ms',
  },
  FCP: {
    cn: '首次内容绘制（First Contentful Paint）：首次渲染出文本/图片等内容的时间。',
    good: 1800,
    ni: 3000,
    unit: 'ms',
  },
  TTFB: {
    cn: '首字节时间（Time to First Byte）：从发起请求到收到服务器第一个字节的时间，越小表示后端/网络越快。',
    good: 800,
    ni: 1800,
    unit: 'ms',
  },
};